import React from 'react';
import "./HowTo.scss";
import { Layout, TitleSecondary } from '../../components';
import { Link } from 'react-router-dom';

const about = () => {

    return (
        <div className="about">
            <Layout background="#1f2024">
                <div className="about__container">
                    <div className="about__data">
                        <TitleSecondary>Quiénes somos</TitleSecondary>
                        <h3>
                            Somos un equipo de profesionales comprometidos con el desarrollo de una plataforma de alto impacto y transformación social para el sector de la construcción y el hogar.
                        </h3>
                        <div className="about__image">
                            <img src="https://images.pexels.com/photos/3184394/pexels-photo-3184394.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" alt="Equipo Solucionarte" />
                        </div>
                        <p className="about__paragraph">
                            <span>Objetivos</span>:
                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quasi qui, error quisquam consequatur voluptatibus quae. Rerum voluptatum quam itaque commodi quaerat blanditiis dolorem.
                        </p>
                        <p className="about__paragraph">
                            <span>Misión</span>:
                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quasi qui, error quisquam consequatur voluptatibus quae. Rerum voluptatum quam itaque commodi quaerat blanditiis dolorem.
                        </p>
                        <p className="about__paragraph">
                            <span>Visión</span>:
                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quasi qui, error quisquam consequatur voluptatibus quae. Rerum voluptatum quam itaque commodi quaerat blanditiis dolorem, sunt corporis culpa recusandae reiciendis quo, dolores unde qui quae. Sit incidunt soluta magnam voluptas voluptatum deleniti facilis repellendus totam iure et? Id, labore perspiciatis.
                        </p>

                        <p className="about__paragraph">
                            <span>Valores</span>:
                            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quasi qui, error quisquam consequatur voluptatibus quae. Rerum voluptatum quam itaque commodi quaerat blanditiis dolorem, sunt corporis culpa recusandae reiciendis quo, dolores unde qui quae. Sit incidunt soluta magnam voluptas voluptatum deleniti facilis repellendus totam iure et? Id, labore perspiciatis.
                        </p>
                    </div>
                </div>
            </Layout>
        </div>
    )
}

export default about;
